/**
 * Created by mnaughton on 10/15/2015.
 */

import BaseFieldView from "core/views/Field/BaseFieldView";
import _ from "underscore";
export default BaseFieldView.extend({
  className: "boolean",
  template: _.template(
    '<input class="form-control" data-role="flipswitch" type="checkbox" <%=value ? \'checked="checked"\' : \'\'%>  name="<%-name%>" value="<%-value%>"/>'
  ),

  events: {
    "change > .form-control": "onChange",
    "keyup > .form-control": "onChange",
  },

  getControlValue: function () {
    return this.$(".form-control")[0].checked;
  },

  setControlValue: function (value) {
    var $formControl = this.$(".form-control");

    if ($formControl.length) {
      $formControl[0].checked = !!value;
    }
  },

  serialize: function () {
    return {
      name: this.field.id,
      value: !!this.getValue(false),
    };
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/core/views/Field/edit/CheckBoxView.js
// module id = 838
// module chunks = 1